import React, { useContext } from 'react'
import SignupContext from 'modules/react/signup/SignupContext'

export default function NewsletterCheckbox ({
  title = 'Tilmeld nyhedsbrev',
  label = 'Ja, jeg vil gerne tilmeldes Tietgenskolens nyhedsbrev',
  slug = 'signup-for-newsletter'
}) {

  const { setFormValue } = useContext(SignupContext)

  return (
    <>
      <div className="title title--h6">{title}</div>
      <div className="input-group">
        <input
          type="checkbox"
          value={slug}
          id={slug}
          name={slug}
          defaultChecked={false}
          onChange={(e) => setFormValue('signupForNewsletter', e.target.checked)}
        />
        <label htmlFor={slug}>{label}</label>
      </div>
    </>
  )
}